import { ApprovalStatusTypeEnum } from "./model-enums";

export class ApprovalStatusType {
  constructor(readonly status: string) {
    switch (status) {
      case ApprovalStatusTypeEnum.Approved:
      case ApprovalStatusTypeEnum.Rejected:
      case ApprovalStatusTypeEnum.Pending:
      case ApprovalStatusTypeEnum.NotApplicable:
      case ApprovalStatusTypeEnum.Unknown:
        break;
      default:
        throw new Error(`Invalid status type ${status}`);
    }
  }
}
